import React, { useState } from 'react'
import '../assets/css/admin/login.css';
import Img from '../assets/images/skillslogo.png';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from 'axios';
import Swal from 'sweetalert2'


const RLogin = () => {

    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const email = e.target.email.value;
        const password = e.target.password.value;
        const role = e.target.role.value;

        if (!email || !password || role === "null") {
            Swal.fire({
                title: "Please fill all fields and select a role",
                icon: "error",
            });
            return;
        }

        setIsLoading(true);

        if (role === "ins") {
            axios.post('https://api.myskills.lk/common/login', { email: email, password: password }).then((response) => {
                setIsLoading(false);
                if (response.data.message === "Invalid") {
                    Swal.fire({
                        title: "Invalid Email or Password",
                        icon: "error",
                    });
                } else {
                    // set session storage FIRST
                    sessionStorage.setItem('id', response.data.id);
                    sessionStorage.setItem('email', response.data.email);
                    sessionStorage.setItem('in_name', response.data.in_name);
                    
                    Swal.fire({
                        title: "Login Successful",
                        icon: "success",
                        timer: 1500,
                        showConfirmButton: false,
                    }).then(() => {
                        if (response.data.country !== "Sri Lanka (ශ්‍රී ලංකාව)") {
                            window.location.href = "/saprofile";
                        } else {
                            window.location.href = "/insprofile"
                        }
                    });
                }
            }).catch((err) => {
                setIsLoading(false);
                console.log(err);
                Swal.fire({
                    title: "Invalid Email or Password",
                    icon: "error",
                });
            })
        } else if (role === "gc") {
            axios.post('https://api.myskills.lk/govofficer/login', { email: email, pass: password }).then((response) => {
                setIsLoading(false);
                if (response.data.message === "Invalid") {
                    Swal.fire({
                        title: "Invalid Email or Password",
                        icon: "error",
                    });
                } else {
                    // set session storage FIRST
                    sessionStorage.setItem('id', response.data.id);
                    sessionStorage.setItem('email', response.data.email);
                    sessionStorage.setItem('gc_name', response.data.name);
                    sessionStorage.setItem('district', response.data.district);
                    
                    Swal.fire({
                        title: "Login Successful",
                        icon: "success",
                        timer: 1500,
                        showConfirmButton: false,
                    }).then(() => {
                        window.location.href = "/gofficer";
                    });
                }
            }).catch((err) => {
                setIsLoading(false);
                Swal.fire({
                    title: "Invalid Email or Password",
                    icon: "error",
                });
            })
        } else if (role === "admin") {
            axios.post('https://api.myskills.lk/admin/login', { email: email, password: password }).then((response) => {
                setIsLoading(false);
                if (response.data.success) {
                    // set session storage FIRST - using the keys AdminDashboard expects
                    sessionStorage.setItem('aid', response.data.user.id);
                    sessionStorage.setItem('aemail', response.data.user.email);
                    sessionStorage.setItem('aname', response.data.user.name);
                    
                    Swal.fire({
                        title: "Login Successful",
                        icon: "success",
                        timer: 1500,
                        showConfirmButton: false,
                    }).then(() => {
                        window.location.href = "/admin/allcourses"; // Update this to an existing admin route
                    });
                } else {
                    Swal.fire({
                        title: response.data.message || "Invalid Email or Password",
                        icon: "error",
                    });
                }
            }).catch((err) => {
                setIsLoading(false);
                console.log(err);
                let errorMessage = "Invalid Email or Password";
                if (err.response && err.response.data && err.response.data.message) {
                    errorMessage = err.response.data.message;
                }
                Swal.fire({
                    title: errorMessage,
                    icon: "error",
                });
            })
        } else {
            setIsLoading(false);
            Swal.fire({
                title: "Please Select a Role",
                icon: "error",
            });
        }
    }

    const selectStyle = {
        width: "100%",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        marginBottom: "20px",
        marginTop: "5px",
        color: "#333",
        fontSize: "16px",
        backgroundColor: "#f9f9f9",
        outline: "none",
    }

    return (
        <div> <div className="login-container">
            <div className="login-box">
                <div className="logo-section">
                    <a href="/"><img src={Img} alt="logo.png" width={150} /></a>
                </div>
                <h3>LOGIN</h3>
                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <input type="email" id="email" name="email" required />
                    </div>
                    <div className="input-group password-container">
                        <label htmlFor="password">Password</label>
                        <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            name="password"
                            required
                        />
                        <span
                            className="toggle-visibility"
                            onClick={togglePasswordVisibility}
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>

                    <div className="input-group">
                        <label htmlFor="role">Role</label>
                        <select name="role" id="role" style={selectStyle} required>
                            <option value="null">Select Role</option>
                            <option value="admin">Admin</option>
                            <option value="ins">Institute</option>
                            <option value="gc">Government Officer</option>
                        </select>
                    </div>

                    <div className="input-group">
                        <a href="/forgot" style={{color:"blue", textTransform:"uppercase", fontSize:"0.8rem"}}  >Forgot Password</a>
                    </div>

                    <button type="submit" className="login-button" style={{ width: "100%" }} disabled={isLoading}>
                        {isLoading ? "Signing In..." : "Sign In"}
                    </button>
                </form>



            </div>
        </div>
        </div>
    )
}

export default RLogin